
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Link } from 'react-router-dom';

// users
import user4 from '../assets/images/users/user-4.jpg';

class ProfileMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
        };
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState(prevState => ({
            menu: !prevState.menu
        }));
    }


    render() {

        return (
            <React.Fragment>
                <Dropdown isOpen={this.state.menu} toggle={this.toggle} className="d-inline-block" >
                    <DropdownToggle className="btn header-item waves-effect" id="page-header-user-dropdown" tag="button">
                        <i className="fa-2x mdi mdi-account-circle-outline"></i>
                    </DropdownToggle>
                    <DropdownMenu right>
                        {/*}<DropdownItem tag="a" href="#"><i className="mdi mdi-settings font-size-17 align-middle mr-1"></i>Instellingen</DropdownItem>
                        <div className="dropdown-divider"></div>*/}
                        <Link
                            to='/logout'
                            className="dropdown-item text-danger">
                            <i className="mdi mdi-logout font-size-17 align-middle mr-1"></i>
                            <span>Uitloggen</span>
                        </Link>
                    </DropdownMenu>
                </Dropdown>
            </React.Fragment>
        );
    }
}

export default withRouter(ProfileMenu);
